import request from '../common/request';

export function lockScreen(data) {
  return request({
    url: `/api/lockscreen/scan`,
    method: 'POST',
    data
  })
}